import { jsxs as o, Fragment as d, jsx as n } from "react/jsx-runtime";
import "react";
import { p as i } from "../../index-B0ARwqly.mjs";
import { classes as s } from "../../utils/helpers.js";
import { SectionedContent as p } from "../SectionedContent/SectionedContent.js";
import { GenericList as m } from "../GenericList/GenericList.js";
import { SocialShareBlock as u } from "../SocialShareBlock/SocialShareBlock.js";
import '../../assets/ShowAboutContent.css';const g = {
  "show-about-content__social-share": "_show-about-content__social-share_80z85_1"
};
function k({
  series: t,
  castStr: a,
  showUpcoming: l,
  type: r,
  nextAirDates: c,
  socialShare: e = {
    enabled: !1,
    url: "",
    text: "",
    longtext: ""
  }
}) {
  const h = () => c.length > 0 ? /* @__PURE__ */ o("div", { className: "upcoming-airings", children: [
    /* @__PURE__ */ n("h3", { className: "h5", children: "Upcoming Airings" }),
    /* @__PURE__ */ n(m, { list: c, classname: "upcoming-airings__list" })
  ] }) : /* @__PURE__ */ o("div", { className: "upcoming-airings", children: [
    /* @__PURE__ */ n("h3", { className: "h5", children: "Upcoming Airings" }),
    /* @__PURE__ */ n("p", { children: r === "series" ? i(`This show doesn't have any episodes scheduled in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href="/schedule" className="inline-anchor">full schedule</a> to see what shows are airing.`) : i(`This movie doesn't have any airings in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href="/schedule" className="inline-anchor">full schedule</a> to see what shows are airing.`) })
  ] });
  return /* @__PURE__ */ o(d, { children: [
    /* @__PURE__ */ n(
      p,
      {
        sections: [
          {
            header: {
              type: "primary",
              title: `About ${t.title}`
            },
            content: t.series_synopsis
          },
          {
            header: {
              type: "secondary",
              title: "Starring"
            },
            content: a === "" ? "" : `<p>${a}</p>`
          },
          {
            header: {
              type: "secondary",
              title: "Director"
            },
            content: t != null && t.director ? `<p>${t == null ? void 0 : t.director}</p>` : ""
          },
          {
            header: {
              type: "secondary",
              title: "Creators"
            },
            content: t != null && t.creators ? `<p>${t == null ? void 0 : t.creators}</p>` : ""
          },
          {
            header: {
              type: "secondary",
              title: "Public & Critical Acclaim"
            },
            content: (t == null ? void 0 : t.public_content) ?? ""
          }
        ]
      }
    ),
    e.enabled && /* @__PURE__ */ n("div", { className: s([g["show-about-content__social-share"], "show-about-content__social-share"]), children: /* @__PURE__ */ n(
      u,
      {
        url: e.url,
        text: e.text,
        longtext: e.longtext
      }
    ) }),
    l && h()
  ] });
}
export {
  k as ShowAboutContent,
  k as default
};
